// extracted by mini-css-extract-plugin
export default {"searchWrapper":"InventorySearch_searchWrapper__GN0Ym","searchIcon":"InventorySearch_searchIcon__JNJ-G","searchInput":"InventorySearch_searchInput__GtbUp"};